package dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun ApiRoute11Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/fullstack/ApiRoute11.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("api-routes") }) {
                org.jetbrains.compose.web.dom.Text("API routes")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""// Backend

interface DataStore {
    fun addText(id: String, text: String)
}

@InitApi
fun initApi(ctx: InitApiContext) {
    ctx.data.add<DataStore>(DataStoreImpl())
}
""", "kotlin 1 <apibackend> [api-init]")
            dev.bitspittle.droidconSf24.components.widgets.Code("""// Backend
@Api
suspend fun contactMe(ctx: ApiContext) {
    val msg: ContactMeMessage
    
    ctx.data.getValue<DataStore>().addText(
        id = "${'$'}{msg.lastName}, ${'$'}{msg.firstName}",
        text = "${'$'}{msg.subject}: ${'$'}{msg.message}"
    )
}
""", "kotlin 6 <apibackend> [api-backend]")
        }
    }
}
